import { Tooltip } from '@mui/material';
import React from 'react';
import AltIcon from './AltIcon';
import CircleTakeIcon from './CircleTakeIcon';

type Props = {
    circle: boolean
    alt: boolean
}

export default function CircleOrAltIcon({ circle, alt }: Props) {
    if (!circle && !alt) return null;

    return (
        <Tooltip arrow title={circle ? 'Circled' : alt ? 'Alt' : ''}>
            <>
                {circle && <CircleTakeIcon />}
                {alt && <AltIcon />}
            </>
        </Tooltip>
    )
}